module.exports = __webpack_public_path__ + "img/6-3.4c76dac0.png";